import React from 'react';
import {
  Checkbox, Button,
} from 'antd';
import {
  Box,
} from '../../shared/components';

export default function FooterDevolver({
  onDevolver, onClose, onChangeCheckbox,
}) {
  let content = '';

  content = (
    <Box mt="12" mb="12">
      {/* <Checkbox
        style={{ marginRight: '170px' }}
        onChange={onChangeCheckbox}
      >
        Imprimir ticket
      </Checkbox> */}
      <Button key="back" onClick={onClose}>
        Cancelar
      </Button>
      <Button style={{ marginRight: '10px' }} key="submit" type="primary" onClick={onDevolver}>
        Devolver artículos
      </Button>
    </Box>
  );

  return content;
}
